import React from 'react';

import './CartMessages.scss';

interface CartMessages {
    cartMessages: string[];
}

export const CartMessages: React.FunctionComponent<CartMessages> = (props) => {
    if (props.cartMessages.length === 0) {
        return null;
    }
    return (
        <div className="cart-messages">
            {props.cartMessages.map((message, index) => (
                <p className="cart-messages__message" key={index}>
                    {message}
                </p>
            ))}
        </div>
    );
};
